<template>
  <component
    :is="tag"
    ref="expandable"
    class="expandable"
    :class="{ active: expanded }"
  >
    <slot v-bind="{ toggle, expanded, expandable, normalHeight, maxHeight }" />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'article',
    },
    maxHeight: {
      type: Number,
      default: 20,
    },
  },

  data () {
    return {
      expanded: false,
      expandable: false,
      normalHeight: 10000,
    }
  },

  mounted () {
    const normalHeight = this.$refs.expandable.scrollHeight
    this.expandable = normalHeight > this.maxHeight

    if(this.normalHeight <= this.maxHeight) {
        this.normalHeight = normalHeight
        this.expandable = false;
    }
  },

  methods: {
    toggle () {
      this.expanded = !this.expanded
    },
  },
}
</script>

<style scoped lang="scss">
.expandable {
  overflow: hidden;
  transition: max-height 0.25s linear;
}
</style>
